export default __webpack_public_path__ + "static/media/featured-in-8.b5a24953.png";